import { render, staticRenderFns } from "./receiptRegistration.vue?vue&type=template&id=6b226bfb&scoped=true"
import script from "./receiptRegistration.vue?vue&type=script&lang=js"
export * from "./receiptRegistration.vue?vue&type=script&lang=js"
import style0 from "./receiptRegistration.vue?vue&type=style&index=0&id=6b226bfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b226bfb",
  null
  
)

export default component.exports